import { render, staticRenderFns } from "./btm.vue?vue&type=template&id=67c874d6&scoped=true&"
import script from "./btm.vue?vue&type=script&lang=js&"
export * from "./btm.vue?vue&type=script&lang=js&"
import style0 from "./btm.vue?vue&type=style&index=0&id=67c874d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c874d6",
  null
  
)

export default component.exports